import {
  localSave,
  localRead
} from "@/libs/util";

import {saveErrorLogger,webLogo,serverMac} from '@/api/data'
//import config from '@/config'
//const {homeName} = config
export default {
 state: {
   local: localRead('local'),
   errorList: [],
   hasReadErrorPage: false,
   logoPath:localRead('logoPath'),
   txtLogo: '',
   sysHeight: '',
   sysWidth: '',
   webVersion:'',
   mac:'',
   theme: 'black',
   autoAccept:false,
   acceptType:'auto',
   isOpenLogo:false,
   serverTime: null,
 },
  mutations:{
    setWebVersion(state, webVersion) {
      state.webVersion = webVersion
    },
    setAcceptType(state,acceptType){
      state.acceptType = acceptType
    },
    setServerTime(state,serverTime) {
      state.serverTime = serverTime
    },
    setAutoAccept(state,autoAccept){
      state.autoAccept = autoAccept
    },
    setLocal (state, lang) {
      localSave('local', lang)
      state.local = lang
    },
    setTheme(state, theme) {
      if (['black', 'white', 'blue'].indexOf(theme) > -1) {
        state.theme = theme
      }
    },
    setTxtLogo(state,txtLogo) {
      state.txtLogo = txtLogo
    },
    addError(state, error) {
      state.errorList.push(error)
    },
    setHasReadErrorLoggerStatus(state, status = true) {
      state.hasReadErrorPage = status
    },
    setLogoPath(state, logoPath) {
      localSave('logoPath', logoPath)
      state.logoPath = logoPath
    },
    setSysHeight(state, sysHeight) {
      state.sysHeight = sysHeight
    },
    setSysWidth(state, sysWidth) {
      state.sysWidth = sysWidth
    },
    setMac(state,mac){
      state.mac = mac
    },
    setIsOpenLogo(state,isOpenLogo){
      state.isOpenLogo = isOpenLogo
    }
  },
  actions: {
    addErrorLog({commit, rootState}, info) {
      if (!window.location.href.includes('error_logger_page')) commit('setHasReadErrorLoggerStatus', false)
      const {user: {token, userId, userName}} = rootState
      let data = {
        ...info,
        time: Date.parse(new Date()),
        token,
        userId,
        userName
      }
      saveErrorLogger(info).then(() => {
        commit('addError', data)
      })
    },
    LogoPath({commit}) {
      return new Promise((resolve, reject) => {
        webLogo().then((res) => {
          let data = res.data
          let status = data.code
          let flag = true;
          if (status === 200) {
            if (data.data !== null) {
              let temp = ''
              let wt = ''
              for (let i = 0; i < data.data.length; i++) {
                let logo = data.data[i]
                if (logo.logoType === 'WebLogo') {
                  wt = logo.logoUrl
                  commit('setLogoPath', logo.logoUrl)
                }
                if (logo.logoType === 'TXTLogo') {
                  flag = false;
                  commit('setIsOpenLogo', true)
                  commit('setTxtLogo', logo.logonName)
                }
                if (logo.logoType === 'ClientLogo') {
                  temp = logo.logoUrl
                }
              }
              if (!wt) {
                commit('setLogoPath', temp)
              }

            }
          }
          if(flag){
            commit('setIsOpenLogo', true)
            commit('setTxtLogo', "")
          }
        }).catch(err => {
          reject(err)
        })
      })

    },
    serverMac({commit},{auth,timestamp}){
      return new Promise((resolve, reject) => {
        serverMac({auth,timestamp}).then(res=>{
          let response = res.data
          if (response.statuscode === '000000' || response.code === 200) {
            commit('setMac',response.data)
            resolve(response.data)
          }else{
            reject()
          }
        })
      })

    }
  }

}



// WEBPACK FOOTER //
// ./src/store/module/app.js